import { useState, useEffect } from 'react';

/**
 * Custom useImage hook — charge une image sans CORS pour les URLs locales
 */
const useImage = (url, crossOrigin) => {
  const [state, setState] = useState({ image: undefined, status: 'loading' });

  useEffect(() => {
    if (!url) {
      setState({ image: undefined, status: 'loading' });
      return;
    }

    const img = new window.Image();

    // Appliquer crossOrigin si demandé (le serveur envoie Access-Control-Allow-Origin: *)
    if (crossOrigin) {
      img.crossOrigin = crossOrigin;
    }

    img.onload  = () => setState({ image: img, status: 'loaded' });
    img.onerror = () => {
      // Retry sans crossOrigin si ça a échoué
      if (img.crossOrigin) {
        const img2 = new window.Image();
        img2.onload  = () => setState({ image: img2, status: 'loaded' });
        img2.onerror = () => setState({ image: undefined, status: 'failed' });
        img2.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
        return;
      }
      setState({ image: undefined, status: 'failed' });
    };

    img.src = url;

    return () => { img.onload = null; img.onerror = null; };
  }, [url, crossOrigin]);

  return [state.image, state.status];
};

export default useImage;